angular
  .module("questionarioAdv.module")
  .component("fiduciarie", {
    templateUrl: "ng/components/questionarioAdv/fiduciarie/fiduciarie.view.html",
    bindings: {
      model: '=',
      exportValidationComponent: '&',
      exportFiduciariaAdded: '&',
      hideShowFiducianti: '&',
      domini: '<',
      resetSupportModel: '<',
      showHideFiduciaria: '<',
      isFiduciarieFull: '<',
      externalLink: '<',
      isPagoDopo: '<',
    },
    controller: FiduciareController,
    controllerAs: 'fiduciarieCtrl'
  })

function FiduciareController(
  $scope,
  $timeout,
  $modalService,
  $financialApiService,
  $rootScope,
  $portalService,
  $configService
) {
  var self = this;

  self.$onInit = function () {
    self.isAru = $portalService.isAru();
    self.showHideNdgSearch = !$configService.getAppConfig().allFunctionalities.includes("FIDUCIARIE_FULL")
    if (!self.model) {
      self.model = [];
    }
    self.fiduciariaAdded = self.model.filter(function (element) {
      return !element.ndg
    });
    self.model = self.model.filter(function (element) {
      return element.ndg
    });
    self.supportModel = {
      tipoLettera: []
    }

    self.supportModelNewFiduciaria = {
      tipoLettera: []
    }
    if (!self.model) {
      self.model = [];
    }
    setDefaulValue();
    checkShowHideFiducianti();
    validateComponent();
  }

  self.$onChanges = function (changed) {
    if (changed && changed.resetSupportModel && typeof changed.resetSupportModel.currentValue != "undefined") {
      self.fiduciariaAdded = [];
    }
  }

  self.getTodaysDate = function () {

    return moment().format("DD/MM/YYYY");
  }



  self.handleChange = function (indice, campo, valueSelected, newOld) {
    if (newOld == 'nuovaFiduciaria') {
      self.fiduciariaAdded[indice][campo].forEach(function (element) {
        if (element.value == valueSelected.value) {
          element.selected = true;
        } else {
          element.selected = false;
        }
      })

    } else {
      self.model[indice][campo].forEach(function (element) {
        if (element.value == valueSelected.value) {
          element.selected = true;
        } else {
          element.selected = false;
        }
      })

    }


    validateComponent();
  }

  var validateComponent = function () {
    var advFull = $configService.getAppConfig() && $configService.getAppConfig().allFunctionalities && $configService.getAppConfig().allFunctionalities.includes('ADV_FULL')
    $timeout(function () {
      if (self.model.length || self.fiduciariaAdded.length) {
        var checkRadioModel = self.model.every(function (element) {
          return (
            element.vigilata != null &&
            element.sopraSoglia != null &&
            (element.fiducianti != null || !advFull) &&
            element.uscitaDaSocieta != null
          );
        });
        var checkRadioSupportModel = self.fiduciariaAdded.every(function (
          element
        ) {
          return (
            element.vigilata != null &&
            element.sopraSoglia != null &&
            (element.fiducianti != null || !advFull) &&
            element.uscitaDaSocieta != null
          );
        });
        var leastOne = true;
        if (self.showHideFiduciaria) {
          leastOne = self.model.length > 0 || self.fiduciariaAdded.length > 0;
        }
      }
      var testFiduciarieFull =
        $scope.fiduciarie.$valid &&
        checkRadioModel &&
        checkRadioSupportModel &&
        leastOne;

      var fiduciariaList = self.fiduciariaAdded.length ? self.fiduciariaAdded : self.model;
      var testFid = fiduciariaList.every(function (x) {
        return !!x.ndg && !!x.ragioneSociale && !!x.piva && !!x.cf
      });

      var testFiduciarie = testFid && leastOne;
      self.exportFiduciariaAdded({
        nuoveFiduciarie: self.fiduciariaAdded
      })
      self.exportValidationComponent({
        valid: self.isFiduciarieFull ? testFiduciarieFull : testFiduciarie
      })
    }, 500);
  }

  self.handleChangeClassicVersion = function (campo, valore, indice, newOld) {
    if (campo.indexOf('piva') >= 0) {
      if (newOld == 'nuovaFiduciaria') {
        if (checkIfFiduciariaIsPresent(self.fiduciariaAdded[indice][campo])) {
          return;
        }
      }
    }
    if (newOld == 'nuovaFiduciaria') {
      self.fiduciariaAdded[indice][campo] = valore;
    } else {
      self.model[indice][campo] = valore;
    }
    validateComponent();
  }

  self.addFiduciaria = function () {
    var newFiduciaria = CreateNewFiduciaria()
    self.fiduciariaAdded.push(newFiduciaria);
    validateComponent();
  }

  var CreateNewFiduciaria = function (dateOfRest) {
    var fiduciaria = {
      ragioneSociale: dateOfRest && dateOfRest.ragioneSociale || null,
      cf: dateOfRest && dateOfRest.cf || null,
      ndg: dateOfRest && dateOfRest.ndg || null,
      piva: dateOfRest && dateOfRest.piva || null,
      vigilata: dateOfRest && dateOfRest.vigilata,
      numeroIscr: dateOfRest && dateOfRest.numeroIscr || null,
      dataIscr: dateOfRest && dateOfRest.dataIscr || null,
      dataLettera: null,
      fiducianti: null,
      uscitaDaSocieta: null,
      note: null,
      tipoLettera: self.domini.tipoLettera,
      hideInfo: dateOfRest && dateOfRest.hideInfo || false
    }

    return fiduciaria
  }

  self.removeFiduciariaDefault = function (indice) {
    self.model.splice(indice, 1);
    validateComponent();
  }

  self.removeFiduciariaAdded = function (indice) {
    self.fiduciariaAdded.splice(indice, 1);
    validateComponent();
  }

  self.radioModify = function (campo, value, index) {
    validateComponent();

    if (campo == 'fiduciantiRilevati') {
      checkShowHideFiducianti()
    }



  }

  var setDefaulValue = function () {
    self.model && self.model.forEach(function (element, index) {
      self.supportModel.tipoLettera[index] = element.tipoLettera && element.tipoLettera.find(function (sel) {
        return sel.selected == true;
      })

    })
    // set default value new fiduciaria 
    self.fiduciariaAdded && self.fiduciariaAdded.forEach(function (element, index) {
      self.supportModelNewFiduciaria.tipoLettera[index] = element.tipoLettera && element.tipoLettera.find(function (sel) {
        return sel.selected == true;
      })

    })

  }

  self.searchFiduciante = function () {
    self.enableModalSearch = true;
    self.supportTitModel = {}
    $("#footerInstant").css("z-index", "-1");
    $('.financial-leasing__footer').css("z-index", "-1");
    $timeout(function () {
      $modalService.openModal('ricercaFiduciarie-modal');
      self.enabledConfirmButton = false;

    }, 200)


  }

  self.closeModal = function () {
    $modalService.closeModal('ricercaFiduciarie-modal');
    self.enableModalSearch = false;
  }

  self.addFidSearch = function (user) {
    if (user.deleted) {

      $rootScope.$broadcast("addAlert", {
        text: "ERROR_ANAG_ANNULLATA"
      });

      $rootScope.disableDoubleClick = false;
      return
    }
    $rootScope.disableDoubleClick = true;
    self.fiduciariaAdded = self.fiduciariaAdded && self.fiduciariaAdded.filter(function (esecutore) {
      return esecutore.piva != null;
    })
    var testExecutAdded = self.fiduciariaAdded && self.fiduciariaAdded.some(function (element) {
      return element.piva == user.metadata.riUserG.piva
    })
    var testExecut = self.model && self.model.some(function (element) {
      return element.piva == user.metadata.riUserG.piva
    })
    if (testExecutAdded || testExecut) {
      $rootScope.$broadcast("addAlert", {
        text: "ALREADY_ADDED_FIDUCIARIA"
      });
      $rootScope.disableDoubleClick = false;
      return
    }
    var newUser = convertDateToFid(user.metadata.riUserG)
    var newTit = CreateNewFiduciaria(newUser);
    self.model.push(newTit);
    $rootScope.disableDoubleClick = false;
    $modalService.closeModal('ricercaFiduciarie-modal');
    validateComponent();
    self.enableModalSearch = false;
    self.enableLoaderButton = false;


    // self.enableLoaderButton = true;
    // $financialApiService
    //   .getSearchRiUserG(user)
    //   .then(function (listAppCustomer) {
    //     if (listAppCustomer.success) {
    //       var newUser = convertDateToFid(listAppCustomer.appCustomerUser.metadata.riUserG)
    //       var newTit = CreateNewFiduciaria(newUser);
    /* if(self.fiduciariaAdded.length && !self.fiduciariaAdded[self.fiduciariaAdded.length-1].cf && !self.fiduciariaAdded[self.fiduciariaAdded.length-1].nome && !self.fiduciariaAdded[self.fiduciariaAdded.length-1].cognome){
      self.fiduciariaAdded[self.fiduciariaAdded.length-1]=newTit;
    }else{
      self.fiduciariaAdded.push(newTit);
    } */

    //     self.model.push(newTit);
    //     validateComponent();
    //   }
    //   $rootScope.disableDoubleClick = false;
    //   $modalService.closeModal('ricercaFiduciarie-modal');
    //   self.enableModalSearch = false;
    //   self.enableLoaderButton = false;
    // })
    // .catch(function (error) {
    //   console.log(error);
    //   $rootScope.disableDoubleClick = false;
    //   $modalService.closeModal('ricercaFiduciarie-modal');
    //   self.enableModalSearch = false;
    //   self.enableLoaderButton = false;
    // })
  }

  self.enabledConfirm = function (value) {
    self.enabledConfirmButton = !!value;
    self.userSelected = value;
  }

  var convertDateToFid = function (fiduciaria) {
    var temp = {}
    if (fiduciaria.professione && fiduciaria.professione.codProfessione == "FVG") {
      temp = {
        ragioneSociale: fiduciaria.ragioneSociale,
        cf: fiduciaria.cf,
        ndg: fiduciaria.ndg,
        piva: fiduciaria.piva,
        vigilata: true,
        numeroIscr: fiduciaria.professione.nIscrAlbo,
        dataIscr: fiduciaria.professione.dataIscrAlbo
      }

    } else {
      temp = {
        ragioneSociale: fiduciaria.ragioneSociale,
        cf: fiduciaria.cf,
        ndg: fiduciaria.ndg,
        piva: fiduciaria.piva,
        vigilata: false,
        hideInfo: true
      }
    }

    return temp;

  }

  var checkIfFiduciariaIsPresent = function (piva) {
    var testModel = self.model.some(function (element) {
      return element.piva == piva
    })

    var testNewAdd = self.fiduciariaAdded.slice(0, (self.fiduciariaAdded.length - 1))
      .some(function (element) {
        return element.piva == piva
      })

    if (testModel || testNewAdd) {
      $rootScope.$broadcast("addAlert", {
        text: "ALREADY_ADDED_FIDUCIARIA"
      });
      self.fiduciariaAdded.pop();

      return true;
    }

    return false;

  }

  self.riabilita = function (index) {
    self.model[index].riattivatoFe = true;
    self.model[index].annullatoFe = false;
  }


  self.annulla = function (index) {
    self.model[index].annullatoFe = true;
    self.model[index].riattivatoFe = false;
  }

  var checkShowHideFiducianti = function () {
    var testModel = self.model.some(function (element) {
      return element.fiducianti
    })

    var testSupportModel = self.fiduciariaAdded.some(function (element) {
      return element.fiducianti
    })

    self.hideShowFiducianti({
      value: testModel || testSupportModel
    })
  }

}